import { useAtomValue, useSetAtom } from "jotai";
import { Icon, Text } from "@zapier/design-system";
import {
  emitEventOnNewCanvasCreationSetter,
  isViewOnlyDowntimeOverrideAtom,
} from "@zapier/canvas-state";
import styles from "./CreateCanvasThumbnail.module.css";

export function CreateCanvasThumbnail() {
  const viewOnlyDowntime = useAtomValue(isViewOnlyDowntimeOverrideAtom);
  const emitEventOnNewCanvasCreation = useSetAtom(
    emitEventOnNewCanvasCreationSetter,
  );

  const handleCreateCanvas = async () => {
    await emitEventOnNewCanvasCreation("Start from scratch");

    /* Triggers a full page reload (don't use router.push or else we will have
       bugs when you press back button and press "Create" button again - see CNVS-1731)

       Wait for the event to be emitted before redirecting or else it might be lost
    */
    setTimeout(() => {
      window.location.href = "/app/canvas/new";
    }, 0);
  };

  return (
    <button
      className={styles.wrapper}
      disabled={viewOnlyDowntime}
      onClick={handleCreateCanvas}
    >
      <div className={styles.inner}>
        <div className={styles.iconWrapper}>
          <Icon name="formAdd" color="UiPrimary" />
        </div>
      </div>
      <div className={styles.textWrapper}>
        <Text type="SmallPrint3Multiline" color="TextDefault">
          Create canvas
        </Text>
      </div>
    </button>
  );
}
